import React, { useState, useRef, useEffect, useContext } from "react";
import { useHistory, NavLink } from "react-router-dom";
import { Grid, Form, Message, } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import atar_logo from "../assets/home/atar_logo.png";
import { StarButton } from '../components'
import { useSelector, useDispatch } from 'react-redux'
import { contactForm } from '../store/AuthRedux'
import { FormValidate } from '../common'
import 'react-toastify/dist/ReactToastify.css';

const ContactUs = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch()
    const history = useHistory();
    const pageActive = useRef(false);
    const contacts = useSelector((state) => state.auth.contactData)
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);
    const [states, setStates] = useState({
        name: "",
        phone: "",
        email: "",
        message: "",
    });

    const [error, setError] = useState({
        name: null,
        phone: null,
        email: null,
        message: null,
    });

    const inputChange = (key, val) => {
        setStates({ ...states, [key]: val });
        setError({ ...error, [key]: null })
    }

    const submit = () => {

        let error = {}

        if (!states.name) {
            error['name'] = 'please enter your name'
        }
        if (!states.phone) {
            error['phone'] = 'please enter your number'
        }
        if (states.phone && !FormValidate.isPhone(states.phone)) {
            error['phone'] = 'please enter valid 10 digit phone number'
        }
        if (!FormValidate.isEmail(states.email)) {
            error['email'] = 'please enter your email'
        }
        if (!states.message) {
            error['message'] = 'please enter your message'
        }

        if (Object.keys(error).length > 0) {
            setError(error)
            return
        }

        pageActive.current = true;
        dispatch(contactForm(states))
        setStates({
            name: "",
            phone: "",
            email: "",
            message: ""
        })
    }

    return (
        <>
            <div className="container-fluid bg clearall">
                <Grid centered columns={16} >
                    <Grid.Row className="order">
                        <NavLink
                            to="">
                            <img className="contactu_logo" src={atar_logo} />
                        </NavLink>
                    </Grid.Row>
                </Grid>

                <div className="contactus">
                    <Grid>
                        <Grid.Row>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <div className="readable">
                                    <h4> {t("contestus.titel")}<span> {t("contestus.titel1")}</span> </h4>
                                    <p>{t("contestus.para")}</p>
                                    <h5>{t("contestus.subtitel")}</h5>
                                    <p>{t("contestus.para")} </p>
                                    <h5>{t("contestus.subtitel1")}</h5>
                                    <p>{t("contestus.para")} </p>
                                    <h5>{t("contestus.subtitel2")}</h5>
                                    <p>{t("contestus.para")} </p>
                                </div>
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                {(contacts && pageActive.current) && (<Message onDismiss={() => history.push("/")} color='green'>{contacts}</Message>)}
                                <div className="reader">
                                    <h4>{t("contestus.details")}  </h4>
                                    <Form className="form   ">
                                        <Form.Field >
                                            <label></label>
                                            <input className={"red_more " + (error.name ? 'red_moreError' : '')} placeholder='Name*' value={states.name} onChange={(e) => inputChange('name', (e.target.value).trimStart())} />
                                            {error.name && (<div className="error">{error.name}</div>)}
                                        </Form.Field>

                                        <Form.Field>
                                            <input type="number" className={"red_more " + (error.phone ? 'red_moreError' : '')}
                                                placeholder='Phone number*' value={states.phone}
                                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === '.') && evt.preventDefault()}
                                                onChange={(obj) => {
                                                    if (obj.target.value.length === 11) return false;
                                                    inputChange('phone', (obj.target.value).trimStart())
                                                }
                                                } />
                                            {error.phone && (<div className="error">{error.phone}</div>)}
                                        </Form.Field>
                                        <Form.Field>
                                            <input className={"red_more " + (error.email ? 'red_moreError' : '')} placeholder='Email ID' value={states.email} onChange={(e) => inputChange('email', (e.target.value).trimStart())} />
                                            {error.email && (<div className="error">{error.email}</div>)}
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.TextArea className={"red_more " + (error.message ? 'red_moreError' : '')} placeholder='Message' rows="6" value={states.message} onChange={(e) => inputChange('message', (e.target.value).trimStart())} />
                                            {error.message && (<div className="error">{error.message}</div>)}
                                        </Form.Field>
                                    </Form>
                                    <Grid centered columns={16} >
                                        <Grid.Row>
                                            <StarButton background={'mainBg'} title={t("contestus.btn")} onClickAction={submit} />
                                        </Grid.Row>
                                    </Grid>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </div>
            </div>

        </>
    );
};



export default ContactUs;
